import {environment} from '../../environments/environment';

export class SettingsService {
  settings = {
    apiHost: environment.apiHost,
    mapsApiKey: environment.mapsApiKey
  };
  
  getSetting(name) {
    return this.settings[name];
  }
  
  setSetting(name, value) {
    this.settings[name] = value;
  }
}
